function AlarmEventController($uibModal, userService, toasterService) {
  const ctrl = this;

  ctrl.onView = alarmEvent => {
    if (!userService.hasAccessAlarms()) {
      toasterService.error('forbidden-error.title', 'forbidden-error.message');
      return;
    }
    $uibModal.open({
      component: 'alarmEventViewDialog',
      windowClass: 'alarm-rule-view-modal-window',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        alarmEvent: () => alarmEvent,
      },
    });
  };
}

angular
  .module('analysis.module')
  .controller('AlarmEventController', AlarmEventController);
